import axios from 'axios';

import { Utils } from 'services/utils';

const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/storage`;
//const BASE_URL = 'http://localhost:8089/storage';

const config = {
	withCredentials: true,
	headers: {
		'Content-Type': 'application/json',
	},
};

export class StorageApi {
	static async getAll(orgId) {
		const url = `${BASE_URL}/${orgId}`;

		const response = await axios.get(url, config);
		if (Utils.isValidResponse(response)) {
			const { storages } = response.data;
			return { storages, errors: null };
		}

		const { error } = response.data;
		return { storages: null, error };
	}
	static async getStorageGraphData(share, resolution = 'day', unit = 'mb', page = 1) {
		if (!share) {
			return { data: null, errors: null };
		}
		const url = `${BASE_URL}/graph/${share}/${resolution}/${unit}/${page}`;
		const response = await axios.get(url, config);
		if (Utils.isValidResponse(response)) {
			const { data, unit } = response.data;
			return { data, unit, errors: null };
		}

		const { error } = response.data;
		return { data: null, error };
	}
	static async getInitialStorageGraphData(shareId, resolution = 'hour', orgId) {
		if (!shareId) {
			return { data: null, errors: null };
		}
		const url = `${BASE_URL}/${orgId}/${shareId}/graph/area/${resolution}`;
		const response = await axios.get(url, config);

		if (Utils.isValidResponse(response)) {
			const { series, unit, categories, error, commitment_amount } = response.data;
			return { series, unit, categories, commitment_amount, error };
		}

		const { error } = response.data;
		return { data: null, error };
	}

	static getStorage() {
		const url = `${BASE_URL}/`;

		return axios.get(url, config);
	}

	static checkIPInventory(orgId) {
		const url = `${BASE_URL}/check/ip/${orgId}`;

		return axios.get(url, config);
	}
	static setSubnet(orgId) {
		const url = `${BASE_URL}/set/subnet/${orgId}`;

		return axios.get(url, config);
	}

	static async get(id, orgId) {
		const url = `${BASE_URL}/${orgId}/${id}`;
		const response = await axios.get(url, config);
		if (Utils.isValidResponse(response)) {
			const { storage, vips, locations, storageWhiteLists } = response.data;
			return { storageDetails: { storage, vips, locations, storageWhiteLists }, errors: null };
		}

		const { error } = response.data;
		return { storages: null, error };
	}

	static async getVIPs(storageId, orgId) {
		const url = `${BASE_URL}/${orgId}/${storageId}/network`;

		const response = await axios.get(url, config);
		if (Utils.isValidResponse(response)) {
			const { vips, available_vips } = response.data;
			return { activeVIPs: vips, availableVIPs: available_vips, error: null };
		}

		const { error } = response.data;
		return { storages: null, error };
	}

	static updateStoragePassword(username, storageId) {
		const url = `${BASE_URL}/password`;
		const params = { username, storageId };

		return axios.post(url, params, config);
	}

	static updateStorage(storage, orgId, shareId) {
		const url = `${BASE_URL}/${orgId}/${shareId}`;

		return axios.post(url, storage, config);
	}

	static getStorageStats(orgId) {
		const url = `${BASE_URL}/${orgId}/stats`;

		return axios.get(url, config);
	}

	static async getStorageGraphData(shareId, resolution = 'hour', unit, page, orgId) {
		if (!shareId) {
			return { data: null, errors: null };
		}
		const url = `${BASE_URL}/${orgId}/${shareId}/graph/area/${resolution}/${unit}/${page}`;
		const response = await axios.get(url, config);

		if (Utils.isValidResponse(response)) {
			const { series, unit, categories, error, commitment_amount } = response.data;
			return { series, unit, categories, commitment_amount, error };
		}

		const { error } = response.data;
		return { data: null, error };
	}

	static addStorage(params = null, orgId) {
		const url = `${BASE_URL}/${orgId}`;
		return axios.post(url, params, config);
	}
	static deleteStorage(params) {
		const url = `${BASE_URL}/${params.organizationId}/${params.id}/delete`;
		return axios.post(url, params, config);
	}
	static changeStoragePassword(params, orgId, shareId) {
		const url = `${BASE_URL}/${orgId}/${shareId}/security`;
		return axios.post(url, params, config);
	}

	static getStorageSecurity(orgId, shareId) {
		const url = `${BASE_URL}/${orgId}/${shareId}/security`;
		return axios.get(url, config);
	}

	static updateWhitelists(params, orgId, shareId) {
		const url = `${BASE_URL}/${orgId}/${shareId}/network/whitelist`;
		return axios.post(url, params, config);
	}
	static updateVIPStatus(storageId, vip, type, orgId) {
		const params = {
			vipAddress: vip,
			action: type,
		};
		const url = `${BASE_URL}/${orgId}/${storageId}/network/vip`;
		return axios.put(url, params);
	}
}
